import { User } from 'src/interfaces/iuser';
import { getDummyMarketURL } from 'src/utils/functions';

export const handleDemoMarketOnClick = dummyMarket => {
  window.open(getDummyMarketURL(dummyMarket), '_self');
};

export const getheadertext = (dashboardState, user: User, showCredits: boolean) => {
  if (dashboardState.showEstimatorDashboard) {
    if (user.estimatorCredits > 0 && user.subscriptionPlan == 'starter') {
      return `Estimator Credits: ${user.estimatorCredits}`;
    } else {
      return `${user.subscriptionPlan} Plan`;
    }
  } else {
    return showCredits ? 'Upgrade' : 'Subscribe';
  }
};

export const handleSubscriptionModalOpen = (
  isLoggedIn,
  centerCoord,
  address,
  setLoginModalOpen,
  setSubscriptionModalOpen
) => {
  if (!isLoggedIn) {
    localStorage.setItem('estimatorCoords', JSON.stringify(centerCoord));
    localStorage.setItem('estimatorAddress', address);
    setLoginModalOpen(true);
  } else {
    setSubscriptionModalOpen(true);
    localStorage.setItem('userOpenSubscriptionModalIntentionally', 'true');
  }
};

export const getIfDemoMarketOptionVisible = (currentPath, dummyMarket) => {
  return currentPath.includes('/airbnb-data') &&
    !currentPath.includes(
      `/airbnb-data/${dummyMarket?.country}/${dummyMarket?.city}/${dummyMarket?.district}`
    );
};
